import { MasterDetailPlugin } from './core';
import type { MasterDetailPluginOptions, DetailTableOptions } from './types';

export { MasterDetailPlugin };
export type { MasterDetailPluginOptions, DetailTableOptions };
